/**
 * @desc 按钮权限
 */

import fetch from '@/utils/request'
import config from '@/config'

export interface QueryParams {}

export function request(): Promise<BaseResponse<defs.ResultBean<Array<defs.SysMenuEntityObject>>>> {
  return fetch({
    url: config.API_HOST + '/auth/user/buttons',
    data: undefined,
    method: 'POST',
    credentials: 'include',
    timeout: 20 * 1000,
  })
}
